import { LayoutStyles } from '../../../types/ppt-slide';

import { GridLayout } from './GridLayout';
import { TextLayout } from './TextLayout';

export * from './BaseLayout';
export * from './GridLayout';
export * from './TextLayout';

export const LAYOUT_COMPONENTS = {
  [LayoutStyles.DEFAULT]: (props) => (
    <TextLayout {...props} textFocus={LayoutStyles.DEFAULT} />
  ),
  [LayoutStyles.CENTERED_FOCUS]: (props) => (
    <TextLayout {...props} textFocus={LayoutStyles.CENTERED_FOCUS} />
  ),
  [LayoutStyles.QUADRANT]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.QUADRANT} />
  ),
  [LayoutStyles.COMPARISON]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.COMPARISON} />
  ),
  [LayoutStyles.LEFT_CONTENT]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.LEFT_CONTENT} />
  ),
  [LayoutStyles.RIGHT_CONTENT]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.RIGHT_CONTENT} />
  ),
  [LayoutStyles.HORIZONTAL_SPLIT]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.HORIZONTAL_SPLIT} />
  ),
  [LayoutStyles.VERTICAL_SPLIT]: (props) => (
    <GridLayout {...props} gridType={LayoutStyles.VERTICAL_SPLIT} />
  ),
};
